import { useHttpClient } from "../http-client";
import { useSupervisorMode } from "../../components/supervisor-mode-provider";
import { useQuery } from "@tanstack/react-query";
import { ApiCategory } from "../types/api-category";

export const useGetCategoriesApi = (params: {
  organizationId: string;
  themeStructureId?: string;
}) => {
  const httpClient = useHttpClient();
  const isSupervisor = useSupervisorMode();

  const getCategories = async ({
    signal,
  }: {
    signal: AbortSignal;
  }): Promise<ApiCategory[]> => {
    const response = await httpClient.get(`/classifier/categories`, {
      params: {
        organization_id: params.organizationId,
        theme_structure_id: params.themeStructureId,
        supervisor: isSupervisor,
      },
      signal,
    });
    return response.data.data;
  };

  return useQuery({
    queryKey: [
      "categories",
      params.organizationId,
      params.themeStructureId,
      isSupervisor,
    ],
    queryFn: getCategories,
    staleTime: Infinity,
  });
};
